import { render, staticRenderFns } from "./AppAnalysisSideCards.vue?vue&type=template&id=963ba522&scoped=true&"
import script from "./AppAnalysisSideCards.vue?vue&type=script&lang=js&"
export * from "./AppAnalysisSideCards.vue?vue&type=script&lang=js&"
import style0 from "./AppAnalysisSideCards.vue?vue&type=style&index=0&id=963ba522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963ba522",
  null
  
)

export default component.exports